import React, {useState} from "react"
import {useRange} from "react-instantsearch"
import {useTranslation} from "react-i18next"

type Props = {
  title: string; attributes: any;
};
const PriceRange = ({title}: Props) => {
  const {range, refine, start} = useRange({
    attribute: "price",
  })
  const {t} = useTranslation()
  const [inputError, setInputError] = useState<boolean>(false)
  const [minValue, setMinValue] = useState<number>(start[0] !== -Infinity ? start[0] : range.min,)
  const [maxValue, setMaxValue] = useState<number>(start[1] !== Infinity ? start[1] : 100,)
  const [inputMinValue, setInputMinValue] = useState<number>(start[0] !== -Infinity ? start[0] : range.min,)
  const [inputMaxValue, setInputMaxValue] = useState<number>(start[1] !== Infinity ? start[1] : 100,)
  const [open, setOpen] = useState(false)

  function setPrice(from: number, to: number) {
    if (from < range.min) {
      from = range.min
    }
    // All products if max is 100
    if (to === 100) {
      to = range.max
    }
    if (from < to) {
      refine([from, to])
    }
  }

  function resetInput({event}: { event: any }) {
    event.target.value = ""
  }

  function setMinFromInput(value: any) {
    if (value === "") {
      return
    }
    value = parseInt(value)
    if (value < maxValue) {
      setInputError(false)
    } else {
      setInputError(true)
    }
    setPrice(value, maxValue)
    setMinValue(value)
    setInputMinValue(value)
  }

  function setMaxFromInput(stringValue: string) {
    if (stringValue === "") {
      return
    }
    const value = parseInt(stringValue)
    if (value > minValue) {
      setInputError(false)
    } else {
      setInputError(true)
    }
    setPrice(minValue, value)
    setMaxValue(value)
    setInputMaxValue(value)
  }

  return (<div
    className={"bb-filter-options custom-price " + (open ? "filter-options-mobile-open" : "")}>
    <h4 className="bb-filter-processed" onClick={() => setOpen(!open)}>
      {t(title)}
    </h4>
    <div className={"price-wrapper"}>
      <div className={"price-input-wrapper slider-wrapper"}>
        <div>
          <h5>{t('Min')}</h5>
          <input
            className={"price-input"}
            max={range.max - 1}
            min={range.min}
            type={"number"}
            value={inputMinValue}
            onChange={(e) => setMinFromInput(e.target.value)}
            onFocus={(e) => resetInput({event: e})}/>
        </div>
        <div>
          <h5>{t('Max')}</h5>
          <input
            className={"price-input"}
            min={range.min}
            type={"number"}
            value={inputMaxValue} // ... fuerza al valor del input para que coincida con la variable de estado...
            onChange={(e) => setMaxFromInput(e.target.value)}
            onFocus={(e) => resetInput({event: e})}/>
        </div>
      </div>
      {inputError && <div className={"price-error"}>
        El precio máximo debe ser superior al mínimo
      </div>}
    </div>
  </div>)
}
export default PriceRange
